module.exports = __webpack_public_path__ + "bf2f6b57cd6438b1e1ca22dd53c319c0.ttf";